export enum Lang {
    en = 'en',
    fr = 'fr'
}

export enum LangName {
    en = 'English',
    fr = 'French'
}

export enum Dir {
    ltr = 'ltr',
    rtl = 'rtl'
}